export default {
  serverList: [
    {
      apiPrefix: 'course',
      name: '课程服务',
    },
    {
      apiPrefix: 'tk',
      name: '题库服务',
    },
    {
      apiPrefix: 'dashboard',
      name: '大数据服务',
    },
    {
      apiPrefix: 'json',
      name: 'cms服务',
    },
    {
      apiPrefix: 'library',
      name: '文库服务',
    },
    {
      apiPrefix: 'schedule',
      name: '进度回传服务',
    },
    {
      apiPrefix: 'teach',
      name: '[王文君本地ai]AI助手服务',
    },
  ],
} as const;
